import { render } from "./cookies-policy.html?vue&type=template&id=ff9af83a&scoped=true&lang=html&external"
import script from "./cookies-policy.vue?vue&type=script&lang=js"
export * from "./cookies-policy.vue?vue&type=script&lang=js"

import "./_cookies-policy.mobile.scss?vue&type=style&index=0&id=ff9af83a&lang=scss&scoped=true&external"
import "./_cookies-policy.desktop.scss?vue&type=style&index=1&id=ff9af83a&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff9af83a"]])

export default __exports__